import script from "./GradeSimulationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GradeSimulationPage.vue?vue&type=script&setup=true&lang=ts"

import "./GradeSimulationPage.vue?vue&type=style&index=0&id=6f0a84b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0a84b0"]])

export default __exports__